<section class="custom-linked-grid">
  <div class="custom-linked-grid__title-container">
    <h3 class="custom-linked-grid__title-container__title">
      {{ title }}
    </h3>
    <span class="custom-linked-grid__title-container__subtitle">
      {{ subTitle }}
    </span>
  </div>

  <div class="custom-linked-grid__container">
    <div class="custom-linked-grid__container__image" *ngFor="let image of images">
      <ng-container *ngTemplateOutlet="imageBlock; context: { image: image }"></ng-container>
    </div>
  </div>
</section>

<ng-template #imageBlock let-image="image" let-editable="image._editable">
  <button
    type="button"
    class="image-block"
    appDisableClickEvent
    [appStoryblokEditable]="editable"
    (click)="clickGridBlock(image.link); goTo(image.link)"
  >
    <img class="image-block__image" src="{{ 'https:' + image.image }}" [alt]="image.button[0].text" />
    <div class="image-block__title">
      <button
        class="image-block__title__button-primary"
        [ngClass]="{ 'image-block__title__button-secondary': image.button[0].type === 'secondary' }"
      >
        {{ image.button[0].text }}
      </button>
    </div>
  </button>
</ng-template>
